import React from 'react';
import landingVideo from '../../assets/LandingVideo.mp4'; // Import your video
import '../../styles/HomeVid.css';

function HomeVid() {
  return (
    <div className='video'>
      <div className='backgroundVideo'>
        <video autoPlay loop muted playsInline>
          <source src={landingVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      
      <div className='contentOverlay'>
        <h2>Where Visionaries find their space</h2>
        <h1>JS Property</h1>
        <p className='bottomText'>Empowering your property journey with Expertise and Trust.</p>
      </div>
    </div>
  );
}

export default HomeVid;
